import { useEffect, useState } from "react";
import { SWReactIcons } from "@similarweb/icons";
import GAVerifiedContainer from "app/components/React/GAVerifiedIcon/GAVerifiedContainer";
import { Disclaimer } from "app/components/React/Banner/Disclaimer";
import { i18nFilter } from "app/filters/i18nFilter";

// Replaces widget-custom-title.html
export const WidgetCustomTitleTemplate = (props) => {
    const { widgetInstance } = props;
    const { viewData, viewOptions, isCompare, data, apiParams, webSource, isAdditionWWSixMonthMode } = widgetInstance;
    const { webSourceText, showTitleTooltip } = viewOptions;
    const { titleIcon, duration, tooltip, title } = viewData;
    const translatedWidgetTitle = i18nFilter()(title);
    const [shouldDisplayGAVerifiedContainer, setShouldDisplayGAVerifiedContainer] = useState(false);

    useEffect(() => {
        const displayContainer = !isCompare() && data.isGAVerified;
        setShouldDisplayGAVerifiedContainer(displayContainer);
    }, [isCompare, data.isGAVerified]);

    return (
        <div className="widget-custom-title">
            {translatedWidgetTitle}
            {showTitleTooltip ? (
                <span
                    className="swHeader-tooltip scss-tooltip scss-tooltip--s"
                    data-scss-tooltip={tooltip}
                >
                    <SWReactIcons
                        className="info-icon-widget-header"
                        iconName="info"
                    />
                </span>
            ) : null}
            {shouldDisplayGAVerifiedContainer ? (
                <GAVerifiedContainer
                    size="SMALL"
                    isActive={true}
                    isPrivate={data.isGAPrivate}
                    tooltipAvailable={true}
                    tooltipIsActive={false}
                    metric={apiParams.metric}
                />
            ) : null}
            <div className="swWidget-subTitle">
                <SWReactIcons
                    className="first-icon-inline"
                    iconName="daily-ranking"
                    size="xs"
                />
                <span>{`${duration}, `}</span>
                {titleIcon ? (
                    <SWReactIcons
                        className="icon-inline"
                        iconName={titleIcon}
                        size="xs"
                    />
                ) : null}
                <span className="margin-left-2">{webSourceText || webSource}</span>
                {isAdditionWWSixMonthMode ? <Disclaimer disclaimerText="wwo.visits.graph.duratiom.disclaimer" /> : null}
            </div>
        </div>
    );
};
